import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ProductProvider } from './context/ProductContext';
import { CartProvider } from './context/CartContext';
import Header from './components/Header';
import Footer from './components/Footer';
import CheckoutBar from './components/CheckoutBar';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import OrderConfirmedPage from './pages/OrderConfirmedPage';
import AboutPage from './pages/AboutPage';
import { Navigate } from 'react-router-dom';
import ContactPage from './pages/ContactPage';
import PartnerPage from './pages/PartnerPage';
import BulkOrderPage from './pages/BulkOrderPage';
import AdminPage from './pages/AdminPage';
import { gtmPageView, pixelPageView } from './utils/pixel';

function PageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    pixelPageView();
    gtmPageView(location);
  }, [location]);
  return null;
}

function App() {
  return (
    <ProductProvider>
      <CartProvider>
        <Router>
          <PageViewTracker />
          <div className="min-h-screen flex flex-col">
            <Header />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/products/:id" element={<ProductDetailPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<Navigate to="/cart" />} />
              <Route path="/order-confirmed" element={<OrderConfirmedPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/partner" element={<PartnerPage />} />
              <Route path="/bulk-order" element={<BulkOrderPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
            <CheckoutBar />
            <Footer />
          </div>
        </Router>
      </CartProvider>
    </ProductProvider>
  );
}

export default App;
